/* eslint no-underscore-dangle: 0 */
import Rollbar from 'rollbar';
import { rollbarEnv } from '../config';
// TODO Rename this file as `logger.js` later.

export const init = (token) => {
  window._rb = new Rollbar({
    accessToken: token,
    captureUncaught: true,
    captureIp: false,
    captureUnhandledRejections: true,
    payload: {
      environment: rollbarEnv,
    },
  });
};

export const log = (...args) => window._rb.info(args.join('\r\n'));

export const warn = (...args) => window._rb.warn(args.join('\r\n'));

export const critical = (...args) => window._rb.critical(args.join('\r\n'));

export const debug = (...args) => window._rb.debug(args.join('\r\n'));

export const error = (...args) => window._rb.error(args.join('\r\n'));
